import React, { useEffect } from 'react';
import { useRecoilState, useRecoilValueLoadable } from 'recoil';
import { dashboardOptionAtom, profileAtom } from '../../../atoms/Atoms';
import Header from './shared-components/Header';
import SalesAnalytics from '../dashboard/shared-components/SalesAnalytics';
import Trends from '../dashboard/shared-components/trends/Trends';
import UserAnalytics from '../dashboard/shared-components/UserAnalytics';
import PrepInventory from '../dashboard/shared-components/PrepInventory';
import TopProducts from '../dashboard/shared-components/TopProducts';

function StoreDashboard() {
  const [dashboardOption, setDashboardOption] = useRecoilState(dashboardOptionAtom);
  const profile = useRecoilValueLoadable(profileAtom);
  const isAdmin =
    profile.contents && (profile.contents.roles.includes('SuperAdmin') ||
    profile.contents.email.includes('gopanza.com'));
  const isStoreManager =
    isAdmin ||
    (profile.contents &&
      (profile.contents.roles.includes('StoreManager') ||
        profile.contents.roles.includes('StoreAdmin')));
  const isTopAnalytics =
    isAdmin ||
    (profile.contents &&
      (profile.contents.roles.includes('TopAnalytics')));
  const isFinance =
      isAdmin ||
      (profile.contents &&
        (profile.contents.roles.includes('Finance')));

  useEffect(() => {
    if (profile) {
      if (!isStoreManager && !isTopAnalytics && !isFinance && !isAdmin) {
        window.location.href = '/';
      } else {
        setDashboardOption(0);
      }
    }
  }, [profile]);

  return (
    <div>
      <Header />
      {dashboardOption === 0 ?
        <SalesAnalytics />
        : null}
      {dashboardOption === 4 ?
        <Trends />
        : null}
      {dashboardOption === 6 ?
        <UserAnalytics />
        : null}
      {dashboardOption === 7 ?
        <PrepInventory />
        : null}
      {dashboardOption === 8 ?
        <TopProducts />
        : null}
    </div>
  );
}

export default StoreDashboard;
